package com.essntl.core.settings.data.supabase.feature

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single
class FeatureSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<FeatureDto> {
    override val schema: String = "odia_superadmin"
    override val tableName: String = "feature"
}